import closeTokens from '@amzn/meridian-tokens/base/icon/close';
import Icon from '@amzn/meridian/icon';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import React, { useState } from 'react';
import { Trans } from 'react-i18next';
import { GLOBAL_BANNER_WINDOW } from '../../constants';
import { Logger } from '../../utils/logger';
import { Button, useTranslation } from '../blocks';

interface GlobalBannerProps {
    gracePeriodMs?: number;
}

const GlobalBanner = ({ gracePeriodMs }: GlobalBannerProps) => {
    useTranslation('siteNotifications');
    const dismissedKey = `globalBannerDismissed_${GLOBAL_BANNER_WINDOW.startDate}_${GLOBAL_BANNER_WINDOW.endDate}`;
    const now = Date.now();
    const cutoffDate = GLOBAL_BANNER_WINDOW.endDate + (gracePeriodMs || 0);
    const shouldBeVisible = GLOBAL_BANNER_WINDOW.startDate <= now && now <= cutoffDate;

    const [dismissed, setDismissed] = useState<boolean>(() => {
        try {
            return localStorage.getItem(dismissedKey) === '1';
        } catch (e) {
            Logger.error('GlobalBanner: failed to read localStorage', e);
            return false;
        }
    });

    if (dismissed || !shouldBeVisible) {
        return null;
    }

    return (
        <Row width={'100%'} spacing={'small'} spacingInset={'small'} backgroundColor={'yellow'}>
            <div style={{ width: '100%', padding: '.25em 10%', textAlign: 'center', position: 'relative' }}>
                <Text type={'h100'} color={'primary'} alignment={'center'}>
                    <Trans
                        i18nKey={'globalBannerText'}
                        ns={'siteNotifications'}
                        components={{
                            signUp: (
                                <a
                                    href={`/help/view/help#purchase-order-reports`}
                                    target={'_blank'}
                                    rel={'noopener noreferrer'}
                                >
                                    {' '}
                                </a>
                            ),
                            news: (
                                <a href={'/news/list/news'} target={'_blank'} rel={'noopener noreferrer'}>
                                    {' '}
                                </a>
                            ),
                        }}
                    />
                </Text>
                <div style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)' }}>
                    <Button
                        onClick={() => {
                            try {
                                localStorage.setItem(dismissedKey, '1');
                            } catch (e) {
                                Logger.error('GlobalBanner: failed to write localStorage', e);
                            }
                            setDismissed(true);
                        }}
                        type={'icon'}
                        aria-label={'Close banner'}
                    >
                        <Icon tokens={closeTokens}>{'Close banner'}</Icon>
                    </Button>
                </div>
            </div>
        </Row>
    );
};

export default GlobalBanner;
